import axios from 'axios'
import * as MODULES from '../module-codes'
import {
  DEFAULT_ROUND_TIMER_MINS,
  DEFAULT_BREAK_TIMER_MINS
} from "../../pages/modules/cirt/constants";
import Vue from 'vue';

export const state = {
  pcsList: [], 
  otherPCSs: [],
  students: [],
  roleList: [],
  rolePreferences: [],
  selectedStudents: [],
  classData: {},
  userHasPcsData: [],
  pcs: '',
  pcsSelect: null,
  pcsHasTeacherMaterials: false, 
  groups: [], 
  selectedPageMode: 'members',
  selectedGroupMode: 'edit', 
  classViewMode: 'members',
  studentsNoGroup: [], 
  openGroup: null,
  loading: true, 
  individualStudent: null, 
  individualGroup: null, 
  DEFAULT_ROUND_TIMER_MINS,
  DEFAULT_BREAK_TIMER_MINS,
  vm: null, 
}
export const getters = {
  individualStudent: state => {
    return state.individualStudent
  },
  individualGroup: state => {
    return state.individualGroup
  },
}

export const actions = {
  loadClassData: ({ commit, state, dispatch }, vm) => {
    commit('SET_LOADING', true)
    commit("SET_VM", vm)
    axios.get('/api/load_pcs').then((responsePCS) => {
      dispatch('getClass').then((responseClass) => {
        commit('SET_CLASS_DATA', responseClass.data[0])
        axios.post('/api/pcss_from_class', {
          params: {
            class: state.classData.class_id
          }
        }).then(responseLists => {
          commit('SET_PCS_LIST', responseLists.data.hasPcs ?? [])
          commit('SET_OTHER_PCSS', responseLists.data.otherPcs ?? [])
          // Stay on same PCS on refresh
          let storedPCS = state.pcsList.find(pcs => pcs.pcs_id === parseInt(localStorage.getItem('pcs')))
          if (storedPCS) {
            commit('SET_PCS_SELECT', storedPCS)
            dispatch('checkForTeacherMaterials')
          }
          else if(state.pcsList.length > 0) {
            commit('SET_PCS_SELECT', state.pcsList[0])
            dispatch('checkForTeacherMaterials')
          }
          else {
            commit('SET_PCS_SELECT', {pcs_id: localStorage.getItem('pcs')})
            dispatch('checkForTeacherMaterials')
          }
          dispatch('getRoles')
          dispatch('getStudents')
        })
      })
    })
  },
  checkForTeacherMaterials: function ({ commit, state }) {
    axios.post('/api/file/pcs/checkForTeacherMaterials', {
        pcs_id: state.pcsSelect.pcs_id
      }).then((response) => {
        commit('SET_PCS_HAS_TEACHER_MATERIALS', response.data)
      })
  },
  getClass: function () {
    return axios
      .post('/api/get_class', {
        params: {
          class: localStorage.getItem('class'),
        },
      })
  },
  refreshClass: function ({commit}){
    axios
    .post('/api/get_class', {
      params: {
        class: localStorage.getItem('class'),
      },
    }).then(response => {
      commit('SET_CLASS_DATA', response.data[0])
    }) 
  },
  getRoles: function ({ commit }) {
    axios.get('/api/load_roles').then((response) => {
      commit('SET_ROLE_LIST', response.data)
    })
  },
  getStudents: function ({ commit, state, rootState, dispatch }) {
    axios
      .post('/api/get_students', {
        params: {
          class: localStorage.getItem('class'),
          pcs: state.pcsSelect.pcs_id
        },
      })
      .then((response) => {
        commit('SET_STUDENTS', response.data)
        // Rember individual pages on refresh
        state.individualGroup = state.students.groups.find(group => group.group_id == rootState.route.params.group_id && group.pcs_id === state.pcsSelect.pcs_id)
        state.individualStudent = {...state.students.students.find(student => student.id == rootState.route.params.student_id), progress: [], phases: []}
        if (state.individualStudent.id >= 0) {
          dispatch('getStudentProgress', state.individualStudent)
        }
        axios.post('/api/teacher/load_all_user_has_pcs').then((response) => {
          commit('SET_PCS_DATA', response.data)
          axios.post('/api/teacher/load_groups').then((response) => {
            commit('SET_GROUPS', response.data)
            dispatch('calculateUnassigned')
            commit('SET_LOADING', false)
          })
        })
      })

  },
  getStudentProgress: function ({ commit, state, rootState, dispatch }, student) {
    axios.post('/api/getStudentProgress', {
      params: {
        class: localStorage.getItem('class'),
        pcs: state.pcsSelect.pcs_id,
        studentId: student.id
      }
    })
    .then((response) => {
      commit('SET_STUDENT_PROGRESS', response.data)  
    })
  },
  // Create two lists of those who have a group or not
  calculateUnassigned: function ({ commit, state, dispatch }) {
    if (state.students !== undefined && state.students.students !== undefined) {
      state.studentsNoGroup = []
      let assignedStudents = []
      state.students.groups.forEach((group) => {
        if (group.pcs_id === state.pcsSelect.pcs_id) {
          group.members.forEach((member) => {
            assignedStudents.push(member.id)
          })
        }
      })
      state.students.students.forEach((student) => {
        let index = assignedStudents.findIndex((id) => id === student.id)
        let userData = state.userHasPcsData.find((obj) => {
          return obj.user_id === student.id && obj.pcs_id === state.pcsSelect.pcs_id && obj.class_id === state.classData.class_id
        })
        if ( index === -1 && userData !== undefined && student.role !== 'teacher') {
          state.studentsNoGroup.push(student)
        }
      })
      
      if (state.studentsNoGroup.length > 0) {
        commit('SET_GROUP_MODE', 'edit')
      }
      else {
        commit('SET_GROUP_MODE', 'view')
      }
    }
  },
  doesUserHavePcs: function ({state}, content) {
    return (
      state.userHasPcsData.find((obj) => {
        return obj.user_id === content.userId && obj.pcs_id === content.pcsId
      }) !== undefined
    )
  },
  updatePcs: function ({ commit, dispatch }, pcs) {
    commit('SET_PCS_SELECT', pcs)
    dispatch('getStudents')
    dispatch('checkForTeacherMaterials')
  },
  // Route Functions
  setPageMode: function ({commit}, name){
    commit('SET_PAGE_MODE', name)
  },
  //Toast Messages
  updateSuccessful({state}, message) {
    state.vm.$bvToast.toast(message, {
      variant: 'success',
      toaster: 'b-toaster-top-center',
      title: `Update Successful`,
      autoHideDelay: 3000,
    })
  },
  updateUnsuccessful({state}, message) {
    state.vm.$bvToast.toast(message, {
      variant: 'danger',
      toaster: 'b-toaster-top-center',
      title: `Update Unsuccessful`,
      autoHideDelay: 5000,
    })
  },

  // Group Functions
  addNewGroup: function({dispatch, state}, pcsId){
    axios.post('/api/create_group', {
      params: {
        class: state.classData.class_id,
        pcs: pcsId,
      },
    })
    .then((response) => {
      axios
        .post('/api/get_group', {
          params: {
            class: state.classData.class_id,
          },
        })
        .then((response) => {
          dispatch('getStudents')
          if(response) {
            let newGroup = response.data[response.data.length - 1] // Get new group
            dispatch('updateSuccessful', "New Group Created")
            // Name Group
            let defaultName = `Group ${response.data.length}`
            dispatch('renameGroup', {groupId: newGroup.group_id, name: defaultName, supressMessage: true})
          }
          else {
            dispatch('updateUnsuccessful', "Server Error")
          }
        })
    })
  },
  updateGroup: function ({ state, dispatch }, {student, groupId, role, refresh}) {
    // Update DOM before updating database
    if(student.groupIndex) {
      let oldIndex = state.students.groups[student.groupIndex - 1].members.findIndex(member => member.id === student.id)
      if (oldIndex !== -1){
        state.students.groups[student.groupIndex - 1].members.splice(oldIndex, 1)
      }
    }
    let groupIndex = state.students.groups.findIndex( groupData => groupId === groupData.group_id)
    let group = state.students.groups[groupIndex]
    if (group) {
      group.group_id = groupId
      group.members.push({groupId: groupId,
                          groupIndex: groupIndex + 1,
                          id: student.id,
                          name: student.name,
                          roleName: role.name,
                          role_id: role.role_id})
      dispatch('calculateUnassigned')
    }
    axios
      .post('/api/add_to_group', {
        params: {
          group: groupId,
          user: [student.id],
          pcs: state.pcsSelect.pcs_id,
          class: state.classData.class_id,
        },
      })
      .then((response) => {
        if(refresh) dispatch('getStudents')
        //this.updateSuccessful("Group updated")
      })
  },
  removeFromGroup: async function({ state, dispatch}, {userToRemove, groupId, refresh}) {
    // Update DOM before updating database
    userToRemove.groupIndex = state.students.groups.findIndex( groupData => groupId === groupData.group_id)
    let oldIndex = state.students.groups[userToRemove.groupIndex].members.findIndex(member => member.id === userToRemove.id)
    if (oldIndex !== -1){
      state.students.groups[userToRemove.groupIndex].members.splice(oldIndex, 1)
      dispatch('calculateUnassigned')
    }  
    axios
      .post('/api/remove_from_group', {
        params: {
          group: groupId,
          user: [userToRemove.id],
          class: state.classData.class_id,
        },
      })
      .then((response) => {
        if(refresh) this.getStudents()
      })
  },
  getGroupName: function ({ dispatch, state }, groupId) {
    let group = state.students.groups.find((group) => group.group_id === groupId)
    if(!group){
      return "NO GROUP"
    }
    if (group.name) {
      return group.name
    } else {
      let defaultName = `Group ${
        state.students.groups.findIndex((group) => group.group_id === groupId) + 1
      }`
      dispatch('renameGroup', {groupId: groupId, name: defaultName, supressMessage: true})
      return defaultName
    }
  },
  renameGroup: function ({dispatch}, payload) {
    axios.post('/api/rename_group', {
      params: {
        groupId: payload.groupId,
        name: payload.name
      }
    }).then((response) => {
      if(!payload.supressMessage){
        dispatch('updateSuccessful', "Group renamed successfully.")
      }
      dispatch('getStudents')
    })
  },
  setOpenGroup({commit}, groupId){
    commit('SET_OPEN_GROUP', {item: {group_id: groupId}})
  },
  clearOpenGroup({commit}){
    commit('SET_OPEN_GROUP', null)
  },
  setIndividualStudent({commit, dispatch}, student){
    dispatch('getStudents')
    commit('SET_INDIVIDUAL_STUDENT', student)
    dispatch('getStudentProgress', student)
  },
  setIndividualGroup({commit, dispatch}, group){
    dispatch('getStudents')
    commit('SET_INDIVIDUAL_GROUP', group)
  },
  // Role Functions
  updateRole: function ({ state, dispatch }, {user, pcs, role, groupId, refresh}) {
    // Update DOM before updating database
    let groupIndex = state.students.groups.findIndex( groupData => groupId === groupData.group_id)
    let group = state.students.groups[groupIndex]
    if (group) {
      let member = group.members.find(member => member.id == user.id)
      if (member) {
        member.role_id = role
      }
    }
    axios
      .post('/api/update_role', {
        params: {
          user: user.id,
          pcs: pcs,
          role: role,
          class: state.classData.class_id
        },
      })
      .then((response) => {
        if (refresh) dispatch('getStudents')
        //this.updateSuccessful("Role Updated")
      })
  },
  setRolePreferences: function ({ state, dispatch, commit }, payload) {
    axios.post('/api/getRolePreferences', {
      params: {
        pcs: payload.pcs,
        class: payload.classId
      }
    })
    .then(response => {
      commit('SET_ROLE_PREFERENCES', response.data)
    })
  },

  //PCS specific functions
  createCirtGame: function ({ state, dispatch}, {params, group}) {
    let groupId = group.group_id
    axios.post(`/api/cirt/begin_game/${groupId}`, {
        seed: 1,
        debug: true,
        rounds: 3,
        force: true,
        ...params,
        round_duration: state.DEFAULT_ROUND_TIMER_MINS * 60,
        break_duration: state.DEFAULT_BREAK_TIMER_MINS * 60
      })
      .then(async (res) => {
        if(res){
          let groupName = await dispatch('getGroupName', groupId)
          dispatch('updateSuccessful',`Game started for ${groupName}`)
        }
        else {
          dispatch('updateUnsuccessful',`Server Error`)
        }
    })
  },
  advanceCirtRound: function ({dispatch}, group) {
    let groupId = group.group_id
    axios.post(`/api/cirt/advanceRound/${groupId}`, {}).then(async (res) => {
      if(res){
        let groupName = await dispatch('getGroupName', groupId)
        dispatch('updateSuccessful',`Game Round Advanced for ${groupName}`)
      }
      else {
        dispatch('updateUnsuccessful',`Server Error`)
      }
    })
  },

}

export const mutations = {
  SET_VM:(state, content) => {
    state.vm = content
  },
  SET_CLASS_DATA: (state, content) => {
    state.classData = content
  },
  SET_PCS_LIST: (state, content) => {
    state.pcsList = content
  },
  SET_OTHER_PCSS: (state, content) => {
    state.otherPCSs = content
  },
  SET_PCS_SELECT: (state, content) => {
    state.pcsSelect = content
  },
  SET_PCS_HAS_TEACHER_MATERIALS: (state, content) => {
    state.pcsHasTeacherMaterials = content
  },
  SET_ROLE_LIST: (state, content) => {
    state.roleList = content
  },
  SET_STUDENTS: (state, content) => {
    state.students = content
    state.students.groups.forEach(group => {
      group.state.forEach(module => {
        if (typeof module.content === 'string' || module.content instanceof String) {
          module.content = JSON.parse(module.content)
        }
      })
    })
  },
  SET_STUDENT_PROGRESS: (state, content) => {
    Vue.set(state.individualStudent, 'progress', content.progress)
    Vue.set(state.individualStudent, 'phases', content.phases)
  },
  SET_PCS_DATA: (state, content) => {
    state.userHasPcsData = content
  },
  SET_GROUPS: (state, content) => {
    state.groups = content
  },
  SET_GROUP_MODE: (state, content) => {
    state.selectedGroupMode = content
  },
  SET_LOADING: (state, content) => {
    state.loading = content
  },
  SET_OPEN_GROUP: (state, content) => {
    state.openGroup = content
  },
  SET_INDIVIDUAL_STUDENT: (state, content) => {
    state.individualStudent = content
    state.individualStudent.progress = []
    state.individualStudent.phases = []
  },
  SET_INDIVIDUAL_GROUP: (state, content) => {
    state.individualGroup = content
  },
  SET_PAGE_MODE: (state, content) => {
    state.selectedPageMode = content
    if (content === "members" || content === "groups") {
      state.classViewMode = content
    }
  },
  SET_ROLE_PREFERENCES: (state, content) => {
    state.rolePreferences = content
  }
}
